import { ArrayUtils, RandomUtils } from '@colonist/utils';
import { CardEnum, TradeResponseStatus } from '@colonist/game-states';
import { TradeErrorHighlightLocationEnum } from './TradeTypes.ts';
(function(TradeUtils) {
    TradeUtils.tradeMaximumWantedResources = 6;
    TradeUtils.delayClosingTradeWhenAllPlayersReject = 1500;
    TradeUtils.DEFAULT_BANK_TRADE_RATIO = 4;
    function getRandomTradeDelayBetweenBounds(automaticTradeResponseDelayBounds) {
        return RandomUtils.randomIntBetween(automaticTradeResponseDelayBounds.mininumTime, automaticTradeResponseDelayBounds.maximumTime);
    }
    TradeUtils.getRandomTradeDelayBetweenBounds = getRandomTradeDelayBetweenBounds;
    TradeUtils.botGamePlayerAutoRejectTradeIfDoesntHaveResourcesDelay = {
        mininumTime: 4000,
        maximumTime: 6000
    };
    TradeUtils.humanGamePlayerAutoRejectTradeIfDoesntHaveResourcesDelay = {
        mininumTime: 5000,
        maximumTime: 7000
    };
    TradeUtils.botTradeFastResponseDelay = {
        mininumTime: 500,
        maximumTime: 1000
    };
    TradeUtils.botTradeSlowResponseDelay = {
        mininumTime: 4000,
        maximumTime: 6000
    };
    TradeUtils.botTradeExecutionIfAllPlayersHaveRespondedDelay = {
        mininumTime: 500,
        maximumTime: 1000
    };
    TradeUtils.botTradeExecutionIfWaitingForPlayersResponseDelay = {
        mininumTime: 10000,
        maximumTime: 12000
    };
    function isOpenEndedTrade(offeredResources, wantedResources) {
        if (offeredResources.includes(CardEnum.AnyResource)) return true;
        if (wantedResources.includes(CardEnum.AnyResource)) return true;
        return false;
    }
    TradeUtils.isOpenEndedTrade = isOpenEndedTrade;
    function getBankTradeRatioError(offeredResources, wantedResources, tradeRatios = {}) {
        const uniqueOfferedResources = ArrayUtils.removeDuplicatesFromArray(offeredResources);
        if (uniqueOfferedResources.length <= 0) return {
            error: {
                key: 'strings:game.errors.tradeErrors.invalidBankTradeRatios'
            },
            payload: {
                isBankTradeButtonDisabled: true
            }
        };
        if (wantedResources.length == 0) return {
            error: {
                key: 'strings:game.errors.tradeErrors.offerIncomplete'
            }
        };
        let validNumberOfWantedCards = 0;
        const cardsWithInvalidTradeRatios = [];
        for (const offeredResource of uniqueOfferedResources){
            var _tradeRatios_offeredResource;
            const tradeRatio = (_tradeRatios_offeredResource = tradeRatios[offeredResource]) !== null && _tradeRatios_offeredResource !== void 0 ? _tradeRatios_offeredResource : 4;
            const offeredResourceAmount = ArrayUtils.countOccurenceOfValueInArray(offeredResources, offeredResource);
            if (offeredResourceAmount % tradeRatio != 0) {
                cardsWithInvalidTradeRatios.push(offeredResource);
                continue;
            }
            const offeredAmount = offeredResourceAmount / tradeRatio;
            if (offeredAmount < 1) {
                cardsWithInvalidTradeRatios.push(offeredResource);
                continue;
            }
            validNumberOfWantedCards += offeredAmount;
        }
        if (cardsWithInvalidTradeRatios.length > 0) {
            return {
                error: {
                    key: 'strings:game.errors.tradeErrors.invalidBankTradeRatios'
                },
                payload: {
                    isBankTradeButtonDisabled: true,
                    highlightCards: {
                        cardsToHighlight: cardsWithInvalidTradeRatios,
                        locations: [
                            TradeErrorHighlightLocationEnum.ProposalOffered
                        ]
                    }
                }
            };
        }
        const allWantedCards = ArrayUtils.removeDuplicatesFromArray(wantedResources);
        if (validNumberOfWantedCards != wantedResources.length) {
            return {
                error: {
                    key: 'strings:game.errors.tradeErrors.bankTradeIncorrectWantedCardCount',
                    options: {
                        count: validNumberOfWantedCards
                    }
                },
                payload: {
                    isBankTradeButtonDisabled: true,
                    highlightCards: {
                        cardsToHighlight: allWantedCards,
                        locations: [
                            TradeErrorHighlightLocationEnum.ProposalWanted
                        ]
                    }
                }
            };
        }
        return undefined;
    }
    TradeUtils.getBankTradeRatioError = getBankTradeRatioError;
    function getBankTradeRatioForCard(bankTradeRatios, card) {
        var _bankTradeRatios_find;
        const ratio = (_bankTradeRatios_find = bankTradeRatios.find((bankTradeRatio)=>bankTradeRatio.resource == card)) === null || _bankTradeRatios_find === void 0 ? void 0 : _bankTradeRatios_find.tradeRatio;
        return ratio !== null && ratio !== void 0 ? ratio : TradeUtils.DEFAULT_BANK_TRADE_RATIO;
    }
    TradeUtils.getBankTradeRatioForCard = getBankTradeRatioForCard;
    function createPlayerTradeState(playerColors, tradeId, tradeData, currentTurnPlayerColors) {
        const isCounterOffer = tradeData.counterOfferInResponseToTradeId != undefined;
        const initialPlayerResponses = {};
        for (const playerColor of playerColors){
            const isPlayerTradeExecutor = isCounterOffer ? currentTurnPlayerColors.includes(playerColor) : playerColor == tradeData.creator;
            if (isPlayerTradeExecutor) continue;
            initialPlayerResponses[playerColor] = TradeResponseStatus.PendingResponse;
        }
        const initialPlayersCreatingCounterOffers = {};
        for (const playerColor of playerColors){
            initialPlayersCreatingCounterOffers[playerColor] = false;
        }
        return {
            id: tradeId,
            creator: tradeData.creator,
            offeredResources: tradeData.offeredResources,
            wantedResources: tradeData.wantedResources,
            playerResponses: initialPlayerResponses,
            counterOfferInResponseToTradeId: tradeData.counterOfferInResponseToTradeId,
            playersCreatingCounterOffer: initialPlayersCreatingCounterOffers,
            ...tradeData.forcedResponse != undefined ? {
                forcedResponse: tradeData.forcedResponse
            } : undefined
        };
    }
    TradeUtils.createPlayerTradeState = createPlayerTradeState;
})(TradeUtils || (TradeUtils = {}));
export var TradeUtils;
